"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgVectorDown = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 20, height: 13, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M19.735 12.518a.89.89 0 0 1-.82.263l-5.853-1.204a.904.904 0 0 1-.695-.656c-.105-.329 0-.7.232-.963l1.495-1.554-3.621-3.786-3.01 3.13c-.464.48-1.2.48-1.663 0L.347 2.077C-.116 1.599-.116.81.347.35.58.11.874 0 1.19 0c.316 0 .61.11.842.35l4.59 4.793 3.01-3.13a1.138 1.138 0 0 1 1.663 0l4.484 4.64 1.494-1.554a.906.906 0 0 1 .653-.284c.084 0 .19.021.273.043.316.11.569.372.632.723l1.158 6.062c.042.328-.021.656-.253.875Z", fill: "#F14949" }) }))); };
exports.default = SvgVectorDown;
